import Pagination from './Pagination'
import DetailList from './DetaiList'
import Divider from './Divider'
import Album from './Album'
import LoadMore from './LoadMore'

// export global component here {'name' => Component}

export default {
  'pagination': Pagination,
  'detail-list': DetailList,
  'detail-list-item': DetailList.Item,
  'divider': Divider,
  'album': Album,
  'load-more': LoadMore
}
